module.exports = __webpack_public_path__ + "assets/img/ma-logo-3805a10e.png";